export const injectScript = onLoadCallback => {
  if (['development', 'test'].includes(process.env.NODE_ENV ?? '')) {
    onLoadCallback();
    return;
  }
  const event = new Event('scriptLoaded');
  const script = document.createElement('script');
  script.src = 'https://static.parastorage.com/unpkg/@sentry/browser@5.30.0/build/bundle.min.js';
  script.crossOrigin = 'anonymous';
  script.onload = () => {
    script.dispatchEvent(event);
  };
  script.addEventListener('scriptLoaded', onLoadCallback);
  document.head.appendChild(script);
};
//# sourceMappingURL=sentry-script.js.map